export default __webpack_public_path__ + "static/media/Wavenew.a602bbbd.svg";